import React, { useContext, useEffect, useState, useCallback } from 'react'
import { Roles } from '../hooks/auth.hook'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";

//import { Button, Form } from 'react-bootstrap';
import { Toaster } from './components/Toaster'

import "./css/AuthPage.css";

export const AuthPage = () => {

    const auth = useContext(AuthContext)
    const languages = useContext(LanguagesContext);
    const { loading, request, error } = useHttp()
    const [form, setForm] = useState({ email: '', password: '' })

    // const [receivedError, setReceivedError] = useState(null)

    const [receivedError, setReceivedError] = useState(error)
    if (error)
        console.log('login error: ', error);

    const fetchActiveLanguage = useCallback(async () => {
        try {
            const fetched = await request('/settings/language/active', 'GET', null, {
                // 'x-access-token': token
            })

            if (fetched.languages) {
                languages.initList(fetched.languages);
                if (fetched.languages.filter(item => item.code === languages.pageLanguage).length === 0)
                    languages.changePageLanguage('en');
                console.log("activeList:", fetched.languages);
            }
            else
                console.log("no activeList languages fetched");

        } catch (e) {
            setReceivedError(e)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    // languages, request -- removed to prevent loops.. todo: need to be refactored?


    useEffect(() => {
        fetchActiveLanguage()
    }, [fetchActiveLanguage])

    const changeHandler = event => {
        setForm({ ...form, [event.target.name]: event.target.value })
    }

    const loginHandler = async () => {
        try {

            const data = await request('/user/login', 'POST', { ...form })

            if (data.role === Roles.User) {
                setReceivedError('Please use the mobile app to login')
                return
            }

            auth.login(data)

        } catch (e) {

            setReceivedError(e)
        }
    }

    return (
        <React.Fragment>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            <div className="ContentBlock">
                <div className="InnerBlock">
                    <div className="ImgBlock">
                        <img
                            className="App-logo" alt=""
                            src="/img/OthrReality-Logo.png"
                        />
                    </div>
                    <form className="FormBlocks">
                        <input className="InputBlock" type="email" name="email" placeholder="Email" value={form.email}
                            onChange={changeHandler} />

                        <input className="InputBlock" type="password" name="password" placeholder="Password" value={form.password}
                            onChange={changeHandler} />
                        {/* <p className='text-white mt-4'>**captcha here**</p> */}
                        <div className='d-flex'>
                            <button className={`ButtonBlock ${loading && "ButtonBlockDisabled"} mr-4`}
                                variant="primary" type="submit" disabled={loading}
                                onClick={loginHandler}>
                                Login
                            </button>
                            {/*
                            <button className={`ButtonBlock ${loading && "ButtonBlockDisabled"}`}
                                variant="primary" disabled={loading}
                                onClick={(e) => { e.preventDefault(); console.log('not implemented') }}>
                                Reset Password
                            </button>
                            */}
                        </div>

                    </form>
                </div>
            </div>

        </React.Fragment>


    )
}
